import { getSceneActions, getSceneState } from "../stores/sceneStore";
import { DEFAULT_SCENE_FLOOR_SIZE } from "../viewer/sceneDefaults";
import {
  getStandardFloorHField,
  MAX_HFIELD_HEIGHT_SCALE,
  STANDARD_FLOOR_HFIELD_NAME,
} from "./terrainFloor";
import { TERRAIN_PRESETS, buildTerrainData } from "./terrainPresetData";
import { shouldBlockSceneAuthoringMutation } from "./physicsGuards";

/**
 * Applies a terrain preset to the standard floor heightfield (centered in scene space).
 * Matches click-to-add behavior in the Terrain panel.
 *
 * @param {string} presetKey
 * @returns {boolean} True if a matching preset was applied.
 */
export function applyTerrainPreset(presetKey) {
  if (shouldBlockSceneAuthoringMutation("applyTerrainPreset")) return false;
  const preset = TERRAIN_PRESETS.find((p) => p.key === presetKey);
  if (!preset) return false;
  const hfields = getSceneState().hfields;
  const halfExtent = DEFAULT_SCENE_FLOOR_SIZE / 2;
  const name = STANDARD_FLOOR_HFIELD_NAME;
  const prev = getStandardFloorHField(hfields);
  const prevScale = Number(prev?.heightScale);
  const heightScale = Math.min(
    MAX_HFIELD_HEIGHT_SCALE,
    Number.isFinite(prevScale) && prevScale >= 0 ? prevScale : 1
  );
  const hfield = {
    name,
    size: [halfExtent, halfExtent, preset.elevation, preset.base],
    nrow: preset.nrow,
    ncol: preset.ncol,
    data: buildTerrainData(preset.key, preset.nrow, preset.ncol),
    heightScale,
  };
  const nextHFields = { ...(hfields || {}), [name]: hfield };
  getSceneActions().setHFields(nextHFields);
  return true;
}
